export type PreviewSlide = {
  /** 9:16 portrait image. Replace the URL to swap a slide. */
  src: string
  label: string
  alt: string
}

export const previewSlides: PreviewSlide[] = [
  {
    // Slide 1
    src: 'https://cdn.magicpatterns.com/uploads/9GYW3rYMvRrAy1axiLbPPU/carrusel-1-tapa.png',
    label: 'Volume 4 cover · Team Systems & Rotations',
    alt: 'Cover of Volume 4: Team Systems & Rotations, with a navy court diagram showing six numbered rotation positions',
  },
  {
    // Slide 2
    src: 'https://cdn.magicpatterns.com/uploads/5BsWSeqy4VLyyEjxbfzv9K/carrusel-2-free-vs-down.png',
    label: 'Skill Spotlight · Free ball vs. down ball',
    alt: 'Page titled Free Ball vs. Down Ball – Read It, Call It, comparing player positions for each call with a coach’s note',
  },
  {
    // Slide 3
    src: 'https://cdn.magicpatterns.com/uploads/tZQhmA9iSXexyhyLkjhH7m/carrusel-3-legal-vs-overlap.png',
    label: 'Rules made simple · Legal position vs. overlap',
    alt: 'Page titled Legal Position vs. Overlap, showing a court with six numbered players and an overlap example to avoid',
  },
  {
    // Slide 4
    src: 'https://cdn.magicpatterns.com/uploads/eJxVjG97bdMTJZEKLkzdg2/carrusel-4-read-the-server.png',
    label: 'Drill card · Read the server, own your seam',
    alt: 'Drill card titled Read the Server – Own Your Seam, with setup, an 18–20 minute timer, a court diagram, levels and an error fix',
  },
  {
    // Slide 5
    src: 'https://cdn.magicpatterns.com/uploads/wxFuGK2EC4S4ymJs7cGCNn/carrusel-5-transition-triangle.png',
    label: 'Team concept · The transition triangle',
    alt: 'Page titled The Transition Triangle, linking defense, attack and coverage with a coach’s note about coverage',
  },
]
